// src/YoutubeIcon.tsx
import { jsx } from "react/jsx-runtime";
var YoutubeIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "18",
    viewBox: "0 0 25 18",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.3757 17.6496H12.3517C12.2774 17.6496 4.83992 17.6353 2.96347 17.1257C1.93163 16.8477 1.12581 16.0414 0.848421 15.0094C0.510993 13.1058 0.348051 11.1754 0.361623 9.24219C0.352905 7.30581 0.520256 5.37264 0.86161 3.46656C1.14662 2.43363 1.94891 1.62362 2.97906 1.32873C4.80395 0.849121 12.0364 0.849121 12.3433 0.849121H12.3685C12.444 0.849121 19.9007 0.863509 21.758 1.37309C22.7876 1.65247 23.5918 2.45711 23.8706 3.48694C24.2188 5.39761 24.3822 7.33737 24.3586 9.27936C24.367 11.2134 24.1993 13.1442 23.8574 15.0478C23.5765 16.0785 22.7701 16.883 21.7388 17.1617C19.9163 17.6449 12.6826 17.6496 12.3757 17.6496ZM9.97768 5.65116L9.97169 12.8452L16.2209 9.24819L9.97768 5.65116Z",
        fill: "#0095E4"
      }
    )
  }
);
var YoutubeIcon_default = YoutubeIcon;

export {
  YoutubeIcon_default
};
